export default __webpack_public_path__ + "static/capabilitiesImg1-d7d0dbfbde29918b9d94f0b5552d0ab4.png";